<template>
	<sf-data-table
		ref="userTable"
		:pageUnit="pageUnit_"
		:totalSize="totalSize_"
		paging
		:columns="columns"
		:rows="userList"
		:stripe="false"
		:selection="false"
		@changedPage="changedPage"
		index
		height="50vh"
	>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@qms/comm/commpopup/UserPopup/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000217'), //사용자ID
					prop: 'userId',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000017'), //사용자
					prop: 'userName',
					minWidth: '150px',
					sortable: false,
					clickEvent: this.scrNameClick,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC001154'), //부서코드
					prop: 'deptCd',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001153'), //부서명
					prop: 'deptName',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000406'), //이메일
					prop: 'email',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001473'), //휴대전화 번호
					prop: 'mobileNo',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC001474'), //전화번호
					prop: 'telNo',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000407'), //비고
					prop: 'remark',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000958'), //협력사
					prop: 'employeeType',
					minWidth: '1px',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000958'), //협력사
					prop: 'employeeName',
					minWidth: '150px',
					sortable: false
				}
			];
		}
	},
	mounted() {},
	methods: {
		...rootMethods,
		...serviceMethods,
		async changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회했기 때문에 중복 조회 하지않도록 처리
				return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('reload', currentPageVal, pageUnitVal);
		},
		rowClick(row, column, devent) {
			// alert(row);
			// this.setState_({ key: 'selectedRow', value: row });
		},
		scrNameClick(row) {
			// userGbn은 하나의 Form에 사용자 찾기가 2건이 필요할 경우 해당 값을 셋팅한다.
			this.$emit('SendData', row, this.searchParams.userGbn);
		}
	}
};
</script>

<style></style>
